import { render } from "./HeaderLogo.vue?vue&type=template&id=58ced741"
const script = {}

import exportComponent from "/home/fsilva/projetos/plate-vision-mobile-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__